<template>
  <header class="header container">
    <div class="header__inner container__inner">
      <router-link class="logo" to="/">
        <img class="logo__icon" src="../../../assets/Top/logo_icon.svg" alt>
        <img
          class="logo__title"
          src="../../../assets/Top/logo_title.svg"
          alt="公立はこだて未来大学情報デザインコース 卒業研究展覧会2019"
        >
      </router-link>
      <div class="linkMenu">
        <router-link class="linkItem" exact-active-class="active" to="/">トップ</router-link>
        <router-link class="linkItem" exact-active-class="active" to="/hakodate">函館展</router-link>
        <router-link class="linkItem" exact-active-class="active" to="/tokyo">東京展</router-link>
        <router-link class="linkItem" exact-active-class="active" to="/exhibits">展示作品</router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'o-Header'
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$white: #fff;
$yellow: #eddb44;
$blue: #009898;

.container {
  margin: 0;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  height: 72px;
  background: #fff;
  border-bottom: solid 1px #dfdfdf;
  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    height: 48px;
    position: relative;
  }
  @media screen and (max-width: 411px) {
    height: 48px;
    position: relative;
  }
}

.logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 48px;
  text-decoration: none;
  &__icon {
    height: 100%;
  }
  &__title {
    height: 65%;
    &:not(:first-child) {
      margin-left: 12px;
    }
  }
  &:hover {
    .logo__icon {
      transition: transform 0.8s;
      transform-style: preserve-3d;
      transform: rotateY(360deg);
    }
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    height: 32px;
  }
  @media screen and (max-width: 411px) {
    height: 32px;
  }
}
.linkMenu {
  @media screen and (min-width: 412px) and (max-width: 768px) {
    display: none;
  }
  @media screen and (max-width: 411px) {
    display: none;
  }
}

.linkItem {
  position: relative;
  padding-bottom: 12px;
  color: #000;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 1.2px;
  cursor: pointer;
  &:not(:first-child) {
    margin-left: 40px;
  }
  transition: all 0.4s ease;
  &::after {
    background: $blue;
    content: "";
    margin: auto;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    transform: scaleX(0);
    transition: all 0.4s ease;
    height: 2px;
    width: 60%;
  }
  &.active,
  &:hover {
    color: $blue;
    &::after {
      transform: scaleX(1);
    }
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    &:not(:first-child) {
      margin-left: 24px;
    }
  }
  @media screen and (max-width: 411px) {
    &:not(:first-child) {
      margin-left: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Header/index.vue